import Swal from 'sweetalert2';
export function showCustomeAlert(type: 'success' | 'error' | 'warning' | 'info', message: string, title: string) {
  return Swal.fire({
    title: title,
    icon: type,
    text: message,
    confirmButtonColor: "#0f2336",
    confirmButtonText: "Ok",
    timer: 2000,
    timerProgressBar: true,
  })
}

export function showCustomeAlertOkCancel(type: 'success' | 'error' | 'warning' | 'info',
  message: string, title: string,
  next?: any) {
  return Swal.fire({
    title: title,
    text: message,
    icon: type,
    showCancelButton: true,
    confirmButtonColor: "#0f2336",
    cancelButtonColor: "#d33",
    confirmButtonText: "Ok",
    cancelButtonText: "Cancel"
  }).then((result) => {
    if (result.isConfirmed && next) {
      next()
    }
  });
}

export function showCustomeUpdate(type: 'success' | 'error' | 'warning' | 'info',
  htmlInput: string, title: string,
  next?: any) {
    return Swal.fire({
    title: title,
    html : htmlInput,
    width : "130vh",
    showCancelButton: true,
    confirmButtonColor: "#0f2336",
    cancelButtonColor: "#d33",
    confirmButtonText: "Ok",
    cancelButtonText: "Cancel"
  }).then((result) => {
    if (result.isConfirmed && next) {
      next()
    }
  });
}